import { defineMessages } from 'react-intl';

const localMessages = defineMessages({
  makingTemplateDownload: '结案报告模版下载',
});

const messages = {
  ...localMessages,
};

export default messages;
